<app-card-template title="Pending Dispositions" (close)="openHome()">
  <div
    class="col-12 position-relative"
    style="max-height: 84vh; overflow-y: auto"
    >
    <!-- Sticky Search Input with Back Button -->
    <div
      class="action-bar mb-4 d-flex justify-content-between align-items-center bg-dark-subtle p-3 rounded-3"
      style="position: sticky; top: 0; z-index: 10"
      >
      <div class="left-actions d-flex gap-3 align-items-center flex-grow-1">
        <input
          type="text"
          class="form-control form-control-dark w-50"
          placeholder="Search by first or last name..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterDrafts()"
          />
          <button class="btn modern-btn grey-btn" (click)="refresh()">
            <i class="fa-solid fa-rotate me-2"></i>Refresh
          </button>
        </div>

        <div class="right-actions d-flex gap-2">
          @if (selectedDraftId) {
            <button
              class="btn modern-btn btn-secondary btn-sm"
              (click)="deselectDraft()"
              >
              <i class="fa fa-arrow-left me-2"></i>Back to All Drafts
            </button>
          }
          @if (!selectedDraftId) {
            <button
              class="btn modern-btn green-btn"
              (click)="sharedService.changeRoute('disposition-selection')"
              >
              <i class="fa-solid fa-plus me-2"></i>Start New Disposition
            </button>
          }
        </div>
      </div>

      @if (!filteredDrafts?.length) {
        <div
          class="text-center text-white fst-italic mt-4"
          >
          No incomplete flows found.
        </div>
      }

      @for (draft of filteredDrafts; track draft; let i = $index) {
        <div class="mt-4">
          @if (shouldShowDraft(draft)) {
            <div
              class="card draft-item position-relative bg-dark-subtle border-secondary"
        [ngClass]="{
          'selected-draft': isSelected(draft.id),
          'no-hover': selectedDraftId,
        }"
              [style.cursor]="selectedDraftId ? 'default' : 'pointer'"
              (click)="selectDraft(draft.id)"
              >
              <div
                class="position-absolute d-flex gap-2"
                style="top: 15px; right: 15px; z-index: 2"
                >
                @if (draft.activeStep < 7) {
                  <button
                    class="btn modern-btn green-btn btn-sm"
                    (click)="resumeDraft(draft); $event.stopPropagation()"
                    title="Next"
                    >
                    <i class="fa-solid fa-arrow-right"></i>
                  </button>
                }
                @if (draft.activeStep >= 7) {
                  <button
                    class="btn modern-btn grey-btn btn-sm"
                    (click)="saveCompletedDraft()"
                    title="Save Completed Form"
                    >
                    <i class="fa-solid fa-floppy-disk"></i>
                  </button>
                }
                <button
                  class="btn modern-btn grey-btn btn-sm"
                  (click)="review4473(draft); $event.stopPropagation()"
                  title="Review PDF"
                  >
                  <i class="fa-regular fa-file-pdf"></i>
                </button>
                <button
                  class="btn modern-btn red-btn btn-sm"
                  [disabled]="isDeletingDraft"
                  (click)="deleteDraftClick(draft.id); $event.stopPropagation()"
                  title="Delete this Form 4473"
                  >
                  <i class="fas fa-trash me-1"></i>
                  {{ isDeletingDraft ? "Deleting..." : "Delete" }}
                </button>
              </div>
              <div class="card-body p-4 text-dark">
                <div class="draft-meta mb-3">
                  <div class="draft-identity">
                  <span class="text-nowrap">
                    <span class="draft-label" style="font-weight: 500">Name:</span>
                    <span class="draft-value">{{ draft.data?.drivers_license?.nameFirst }}</span>
                    <span class="draft-value">
                    {{ draft.data?.drivers_license?.nameLast?.charAt(0) || "UNKNOWN" }}
                    </span>
                  </span>
                  <span class="text-nowrap">
                    <span class="draft-label" style="font-weight: 500">DL# </span>
                    <span class="draft-value">{{ draft.data?.drivers_license?.licenseNumber || "N/A" }}</span>
                  </span>
                  <span class="text-nowrap fs-6">
                    <span class="draft-label" style="font-weight: 500">Started: </span>
                    <span class="draft-value">{{ draft.timestamp | date: "short" }}</span>
                  </span>
                  </div>
                @if (draft.data?.reserved_firearms?.length) {
                  <div class="draft-reserved">
                    <span class="draft-label" style="font-weight: 500">Reserved:</span>
                    @for (rf of draft.data.reserved_firearms; track rf; let idx = $index) {
                      <span class="draft-value fw-medium">{{ rf.firearm }}</span>
                      @if (rf.serial_number) {
                        <span class="draft-value ms-1">
                          (SN: {{ rf.serial_number }})
                        </span>
                      }
                      @if (idx < draft.data.reserved_firearms.length - 1) {
                        <span
                          >,
                        </span>
                      }
                    }
                  </div>
                }
                </div>
                <mat-progress-bar
                  mode="determinate"
                  [value]="getCompletionPercentage(draft)"
                  class="mb-2 rounded"
                ></mat-progress-bar>
                <p class="mb-1 text-muted">
                  <span class="text-dark" style="font-weight: 500">Progress:</span>
                  {{ getCompletionPercentage(draft) }}% - Missing steps highlighted in
                  <span class="text-danger fw-medium">Red</span>
                </p>
                <div
                  (click)="onStepperClick($event, draft); $event.stopPropagation()"
                  style="cursor: default"
                  class="dark-stepper-container"
                  >
                  <mat-horizontal-stepper
                    [linear]="false"
                    [selectedIndex]="draft.activeStep"
                    class="mini-stepper bg-transparent"
                    (selectionChange)="onStepChange($event, draft)"
                    >
                    <ng-template matStepperIcon="edit">
                      <i class="fa-solid fa-check"></i>
                    </ng-template>
                    <ng-template matStepperIcon="done">
                      <i class="fa-solid fa-check"></i>
                    </ng-template>
                    @for (config of stepConfigs; track config; let stepIndex = $index) {
                      <mat-step
                        [completed]="isStepCompleteInDraft(draft, stepIndex)"
                        >
                        <ng-template matStepLabel>
                          <span
                            [style.cursor]="stepIndex > 2 ? 'pointer' : 'default'"
                    [ngClass]="{
                      'text-primary fw-medium': stepIndex === draft.activeStep,
                      'text-danger fw-medium': stepIndex !== draft.activeStep && !isStepCompleteInDraft(draft, stepIndex),
                      'text-muted': stepIndex !== draft.activeStep && isStepCompleteInDraft(draft, stepIndex)
                    }"
                            >
                            {{ config.label }}
                          </span>
                        </ng-template>
                      </mat-step>
                    }
                  </mat-horizontal-stepper>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </app-card-template>
